module.exports = __webpack_public_path__ + "2f7186a6853df42545203e1c4e040d81.png";